import { render, staticRenderFns } from "./DatePickerDefault.vue?vue&type=template&id=22217559"
import script from "./DatePickerDefault.vue?vue&type=script&lang=js"
export * from "./DatePickerDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VDatePicker,
  VMenu,
  VTextField,
})
